<!--Header-->
<app-landingpage-header-child [disableLogin]="true"></app-landingpage-header-child>
<!-- End Header-->

<div id="wrapper" class="d-flex justify-content-center">
    <div style="width: 60%;">
        <div>
            <h3 class=" mt-4 font-weight-bold text-center d-block w-100" style="color: #3d3d3d;">
                {{'kyc.identification_method_title' | translate}}</h3>
        </div>
        <div style="color: black; font-weight: 500; font-size: 16px;" class="my-4">
            <div>{{'kyc.not_identification' | translate}}</div>
            <div class="pb-2">{{'kyc.identification_method_note' | translate}}</div>
            <div class="pl-3 pb-2">
                <div class="d-flex">
                    <div><strong><span>-</span></strong></div>
                    <div class="pl-1"><span><strong>
                                {{'kyc.confirm_account_message' | translate}}:</strong>&nbsp;
                            {{'kyc.confirm_account_describe' | translate}}</span></div>
                </div>

            </div>
            <div class="pl-3">
                <div class="d-flex">
                    <div><strong><span>-</span></strong></div>
                    <div class="pl-1">
                        <span>
                            <strong>
                               {{'kyc.identification_otp' | translate}}</strong>
                            <span [innerHTML]="'kyc.identification_otp_describe' | translate"></span>
                        </span>
                    </div>
                </div>
            </div>
            <div [innerHTML]="'kyc.identification_otp_describe_2' | translate" style="padding-left: 3rem;"></div>
        </div>
        <div class="btn-group text-center mat-card-actions ng-tns-c1-0 pt-3 pb-5 d-flex justify-content-center">
            <button mat-stroked-button class="mr-3 mat-stroked-button mat-primary" (click)="onBack()">
                <mat-icon class="mr-0">cancel</mat-icon>
                {{ 'button.exit' | translate }}
            </button>
            <button (click)="onConfirm()" mat-stroked-button class="mr-3 mat-stroked-button mat-primary">
                <mat-icon class="mr-0">person</mat-icon>
                {{'kyc.confirm_account' | translate}}
            </button>
            <button (click)="onIdentificationOtp()" mat-raised-button color="primary"
                class="mr-3 mat-raised-button mat-primary">
                <mat-icon class="mr-0">email</mat-icon>
                {{'kyc.identification_otp_button' | translate}}
            </button>
        </div>
    </div>
</div>